import { useEffect, useState } from 'react';

// Counts down from 00:17:34 and restarts automatically when it reaches zero.
const DURATION_SECONDS = 17 * 60 + 34;
const START = Date.now();

function getRemaining(now: number): number {
  const elapsed = Math.floor((now - START) / 1000);
  return DURATION_SECONDS - (elapsed % (DURATION_SECONDS + 1));
}

export function useCountdown() {
  const [remaining, setRemaining] = useState(() => getRemaining(Date.now()));

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining(Date.now())), 1000);
    return () => window.clearInterval(id);
  }, []);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  const pad = (v: number) => String(v).padStart(2, '0');

  return { hours: pad(hours), minutes: pad(minutes), seconds: pad(seconds) };
}
